import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentWidget } from '../Redux/Reducers/deviceConfigReducer';
import { nonCompWidgetClick } from '../js/nonCompWidgetClick';
import { setShowLoginModal, setShowLogoutPopUp, setShowOfflineMessage } from '../Redux/Reducers/appConfigReducer';

const useWidgetClickHandler = (props) => {
  const navigation = useNavigation();
  const dispatch = useDispatch();

  const {brandingColors} = useSelector(
    state => state.deviceConfigSlice,
  );

  const { isOnline, isLoggedIn } = useSelector(state => state.appConfigSlice)

  const handleShowLoginModal = () => {
    dispatch(setShowLoginModal(true))
  }
  
  const handleOnWidgetClick = useCallback(
    (widgetData) => {
      console.log(widgetData);

      if(!isOnline) {
          dispatch(setShowOfflineMessage(true));
          return;
      }
      
      if (widgetData.path) {
        dispatch(setCurrentWidget(widgetData));
        navigation.navigate(widgetData.path);
      } else {
        dispatch(nonCompWidgetClick(widgetData, navigation));
      }
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, navigation, isOnline, props]
  );

  return handleOnWidgetClick;
};

export default useWidgetClickHandler;
